import Immutable from "immutable";
import {
  FLAG_GETTING_CURRENCY_RATE,
  CLEAR_CURRENCY_RATE,
  GET_CURRENCY_RATE
} from '../../../actions/types/sap-service-layer/CurrencyRate'

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});


export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_CURRENCY_RATE:
      return state.setIn(['current', 'loading'], true);
    case GET_CURRENCY_RATE:
      return state.mergeIn(['current', 'content'], payload);
    case CLEAR_CURRENCY_RATE:
      return INITIAL_STATE;
    default:
      return state;
  }
}